module.exports = __webpack_public_path__ + "img/facility1.e9b2fb7a.svg";